import { useLocation } from 'react-router-dom';

import { ClusterSettings } from '@typings';
import { cn, ensureArray } from '@utils';

import { Link } from '@components';

type Props = {
  tabs: { title: string; path: string | string[] }[];
  rightTabComponent?: React.ReactNode;
};

export const BillingTabs = ({ tabs, rightTabComponent }: Props) => {
  const { pathname } = useLocation();

  const makeTab = ({ path, title }: ClusterSettings.Tab) => {
    const urls = ensureArray(path);
    const isActive = urls.includes(pathname);
    const url = urls[0];

    return (
      <Link
        theme
        key={url}
        className={cn(
          'block border-b-2 border-transparent pb-4 pt-2 text-h6 capitalize text-neural-04 transition-colors hover:text-rebecca',
          { 'border-primary text-rebecca': isActive },
        )}
        to={url}
      >
        {title}
      </Link>
    );
  };

  return (
    <header className="flex place-content-between border-b border-neural-01 px-10 pt-6">
      <div className="flex gap-10">{tabs.map(makeTab)}</div>
      <div>{rightTabComponent}</div>
    </header>
  );
};
